module.exports = __webpack_public_path__ + "static/fastieth-4843f25c843f17209e612f3d8c56733f.png";